"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'userReviewe',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  computed: {
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  data: function data() {
    var _this = this;
    return {
      son_id: this.$route.query.son_id || '',
      form: {
        'begin': new Date(new Date().toLocaleDateString()).getTime(),
        'end': new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
      },
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      stat_data: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        start: 1,
        page_num: 1,
        change_type: 1,
        limit: 20
      }
    };
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;
      var listQuery = Object.assign({}, this.form, this.listQuery, {
          start: this.listQuery.start - 1
        }),
        url = 'agentapi/search/query_user_consume';
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end, '{y}-{m}-{d}');
      this.$get(url, listQuery).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.list;
        _this2.stat_data = res.stat_data;
        _this2.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this2.tableMaxH = window.innerHeight - _this2.$refs.list_table.$el.offsetTop - 80;
      }).catch(function () {
        _this2.listLoading = false;
      });
    }
  }
};